// removed by extract-text-webpack-plugin
module.exports = {"email-field":"email-field__158o7","mega-error":"mega-error__3hv31","emailError":"emailError__2nEjF"};


//////////////////
// WEBPACK FOOTER
// ./styles/formBox.scss
// module id = 1206
// module chunks = 68